"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TheSpiritOfTheMill() {
  return <section data-section-id="230793" id="aerial-intelligence-redefined" className="bg-background text-foreground py-24 md:py-36 px-4 flex items-center justify-center min-h-[70vh]">
      <div className="max-w-3xl mx-auto flex flex-col items-center justify-center text-center">
        <div className="max-w-md w-full mb-8" style={{
        maskImage: "radial-gradient(ellipse at center, black 55%, transparent 80%)",
        WebkitMaskImage: "radial-gradient(ellipse at center, black 55%, transparent 80%)"
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655034/img/dji_matrice_4_branded_survey_drone.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655034/img/dji_matrice_4_branded_survey_drone.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655034/img/dji_matrice_4_branded_survey_drone.png-wvc-sizes" alt="DJI Matrice 4 professional survey drone" loading="lazy" className="w-full h-48 sm:h-56 md:h-64 object-cover" />
        </div>

        <h1 className="font-default text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-widest mb-6 md:mb-8">
          Vertexas
        </h1>

        <p className="text-muted-foreground text-base sm:text-lg md:text-xl max-w-2xl mb-8">
          Residential and commercial roof and facade surveys, aerial photography, and progression reports — working with homeowners and end users as well as professional services and businesses, with nationwide coverage.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full max-w-xl mb-10">
          <div className="bg-card text-card-foreground border border-border p-5 text-center flex flex-col items-center justify-center">
            <span className="text-xs uppercase tracking-wider text-muted-foreground mb-2 font-medium">
              Residential Roof Surveys
            </span>
            <div className="flex items-baseline justify-center gap-1.5">
              <span className="text-xs sm:text-sm text-muted-foreground uppercase font-medium">from</span>
              <span className="text-2xl sm:text-3xl font-bold text-foreground">£200</span>
              <span className="text-xs sm:text-sm text-muted-foreground font-medium">+ VAT</span>
            </div>
          </div>

          <div className="bg-card text-card-foreground border border-border p-5 text-center flex flex-col items-center justify-center">
            <span className="text-xs uppercase tracking-wider text-muted-foreground mb-2 font-medium">
              Commercial Roof Surveys
            </span>
            <div className="flex items-baseline justify-center gap-1.5">
              <span className="text-xs sm:text-sm text-muted-foreground uppercase font-medium">from</span>
              <span className="text-2xl sm:text-3xl font-bold text-foreground">£400</span>
              <span className="text-xs sm:text-sm text-muted-foreground font-medium">+ VAT</span>
            </div>
          </div>
        </div>

        <Button asChild size="lg">
          <Link to="#contact-us">Request a Quote</Link>
        </Button>
      </div>
    </section>;
}